import { Component, OnInit, Directive } from "@angular/core";
import { Global } from "../../../global";
import { AppHeaderService, AppPage } from "./app-header.service";
import { ActivatedRoute, Router } from "@angular/router";
import { NavController, MenuController } from "@ionic/angular";
import { IntroService } from "src/app/services/intro.service";
import { MediaComponent } from "src/app/modals/media/media.component";
import { ModalController } from "@ionic/angular";
import { VersionPage } from "src/app/modals/version/version.page";

@Component({
  selector: "app-app-header",
  templateUrl: "./app-header.component.html",
  styleUrls: ["./app-header.component.scss"],
})
export class AppHeaderComponent implements OnInit {
  appPages = this.appHeaderService.appPages;
  selectedPage: AppPage;
  navigateToURL: string = "/home";
  selectedPageUrl: string = "/home";
  busyClicking: boolean = false;
  currentYear: number;

  constructor(
    public globals: Global,
    private appHeaderService: AppHeaderService,
    private router: Router,
    public navCtrl: NavController,
    private menu: MenuController,
    private introService: IntroService,
    private mediaModal: MediaComponent,
    private modalController: ModalController
  ) {
    this.appHeaderService.appHeaderEmitter.subscribe((url) => {
      this.selectedPageUrl = url;
    });
    this.selectedPage = this.appHeaderService.appPages.find(
      (p) => p.url == "/home"
    );
    this.globals.ContentPageTitle = this.findTitleForUrl(
      this.appHeaderService.appPages,
      this.selectedPage.url
    );

    this.appHeaderService.appHeaderEmitter.subscribe((res) => {
      var selectedURL = res;
      var recursive = this.findTitleForUrl(
        this.appHeaderService.appPages,
        selectedURL
      );

      this.globals.ContentPageTitle = recursive;
    });
    this.globals.fixXRSUser();

    this.currentYear = new Date().getFullYear();
  }
  findTitleForUrl(arr: any, url: string) {
    for (let item of arr) {
      if (item.url === url) {
        return item.title;
      } else if (item.children.length > 0) {
        const title = this.findTitleForUrl(item.children, url);
        if (title !== null) {
          return title;
        }
      }
    }
    return null;
  }

  mainMenuClick(selectedPage: any, pages: any, url: string) {
    if (!this.busyClicking) {
      this.selectedPageUrl = url;
      this.appHeaderService.setByUrl(url);
      this.router.navigate([url], {
        queryParams: {
          displayState: "normal",
          navigatedFromLink: url,
          replaceUrl: true,
        },
        replaceUrl: true,
      });

      //force show Media Modal, because it is not a page
      if (selectedPage == "Manage Content") {
        this.mediaModal
          .show("Manage content", "")
          .then(async (outputReturned: any) => {});
      }

      // Collapse all other open menu items and reset their state
      pages.forEach((page: any) => {
        if (page !== selectedPage) {
          this.resetMenuState(page);
          // page.open = false;
        }
      });

      // Toggle the selected page
      selectedPage.open = !selectedPage.open;
      this.saveMenuState();
      localStorage.setItem("selectedPageUrl", url);
    }
    this.busyClicking = false;
  }

  resetMenuState(page: any) {
    page.open = false;
    if (page.children) {
      page.children.forEach((child: any) => this.resetMenuState(child));
    }
  }

  navigateToHome() {
    this.selectedPageUrl = "/home";
    this.appHeaderService.setByUrl(this.selectedPageUrl);
    this.router.navigate(["/home"], {
      queryParams: {
        displayState: "normal",
        navigatedFromLink: "/home",
        replaceUrl: true,
      },
      replaceUrl: true,
    });
  }
  saveMenuState() {
    const state = this.appPages.map((page) => ({
      title: page.title,
      open: page.open,
      children: this.mapChildrenState(page.children),
    }));
    localStorage.setItem("menuState", JSON.stringify(state));
  }

  mapChildrenState(children: any[]) {
    return children.map((child) => ({
      title: child.title,
      open: child.open,
      children: this.mapChildrenState(child.children),
    }));
  }

  subMenuClick(selectedPage: any, pages: any, url: string) {
    if (!this.busyClicking) {
      this.selectedPageUrl = url;
      this.appHeaderService.setByUrl(url);

      this.router.navigate([url], {
        queryParams: { displayState: "normal", navigatedFromLink: url },
        replaceUrl: true,
      });

      pages.forEach((page: any) => {
        if (page !== selectedPage) {
          this.resetMenuState(page);
          page.open = false;
        }
      });

      selectedPage.open = !selectedPage.open;
      this.saveMenuState();
      localStorage.setItem("selectedPageUrl", url);

      this.busyClicking = true;
    }
  }

  subSubMenuClick(selectedPage: any, pages: any, url: string) {
    if (!this.busyClicking) {
      this.selectedPageUrl = url;
      this.appHeaderService.setByUrl(url);
      this.router.navigate([url], {
        queryParams: { displayState: "normal", navigatedFromLink: url },
        replaceUrl: true,
      });

      pages.forEach((page: any) => {
        if (page !== selectedPage) {
          this.resetMenuState(page);
          page.open = false;
        }
      });

      selectedPage.open = !selectedPage.open;
      this.saveMenuState();
      localStorage.setItem("selectedPageUrl", url);

      this.busyClicking = true;
    }
  }

  ngOnInit() {
    const savedState = localStorage.getItem("menuState");
    const savedPageUrl = localStorage.getItem("selectedPageUrl");

    if (savedState) {
      const state = JSON.parse(savedState);
      this.restoreMenuState(this.appPages, state);
    }
    if (savedPageUrl) {
      this.selectedPageUrl = savedPageUrl;
      this.appHeaderService.setByUrl(savedPageUrl);
      this.router.navigate([savedPageUrl], {
        queryParams: {
          displayState: "normal",
          navigatedFromLink: savedPageUrl,
          replaceUrl: true,
        },
        replaceUrl: true,
      });
    } else {
      this.selectedPageUrl = "/home";
      this.appHeaderService.setByUrl(this.selectedPageUrl);
      this.router.navigate(["/home"], {
        queryParams: {
          displayState: "normal",
          navigatedFromLink: "/home",
          replaceUrl: true,
        },
        replaceUrl: true,
      });
    }
  }

  async openModal() {
    const modal = await this.modalController.create({
      component: VersionPage,
      cssClass: "",
    });
    await modal.present();
  }

  restoreMenuState(pages: any[], state: any[]) {
    pages.forEach((page, index) => {
      const savedPage = state.find((p) => p.title === page.title);
      if (savedPage) {
        page.open = savedPage.open;
        if (page.children && savedPage.children) {
          this.restoreMenuState(page.children, savedPage.children);
        }
      }
    });
  }
}
